// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"66":"f8042d3b","215":"e0e91ffd","721":"14ff5f84","851":"e9aa31cd"}[chunkId] + ".js";
};